<template lang="pug">
  .height-100
    h3.title Gestión de contratos de mi equipo
    p

    transition-group.contenedor-box(name="fade-smooth-two", tag="div")
      .box.position-relative(v-if="mostrarListaSolicitudesPorAprobar", key="lista_solicitud_por_aprobar")
        lista-solicitudes-por-aprobar(
          @close="mostrarListaSolicitudesPorAprobar = false"
        )
      .box.position-relative(v-if="mostrarListaEquipo", key="lista_equipo")
        lista-equipo-contratos(
          @close="mostrarListaEquipo = false"
        )

</template>

<script>
import ListaSolicitudRenovacionContratoPorAprobarComponent from './Component_Contratos_Lista_Solicitud_Renovacion_Contrato_Por_Aprobar'
import ListaEquipoVacacionesComponent from './Component_Contratos_Lista_Equipo'
export default {
  name: 'contratos-equipo',
  components: {
    'lista-solicitudes-por-aprobar': ListaSolicitudRenovacionContratoPorAprobarComponent,
    'lista-equipo-contratos': ListaEquipoVacacionesComponent
  },
  data () {
    return {
      mostrarListaSolicitudesPorAprobar: true,
      mostrarListaEquipo: true
    }
  },
  watch : {
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-box
    display flex
    justify-content center
    flex-direction column
    position relative
    >*
      transition all .5s
      width 100%

</style>



// WEBPACK FOOTER //
// View_Contratos_Equipo.vue?6ee8d006